module.exports = __webpack_public_path__ + "logo-sipgate.svg?ee8a86dac4bbc3d4ff24b27efcac008d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-sipgate.svg
// module id = 8
// module chunks = 0